import { IAccountData } from '../core/interfaces/account-data.interface';

export const isReseller = (account?: IAccountData | null): boolean => {
  return Boolean(account?.data?.user_metadata?.reseller);
};
